import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  /* display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start; */
  font-family: Spoqa Han Sans Neo;
`;

const Inner = styled.div`
  
`;

const PageTitleBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  font-weight: 700;
  padding-bottom: 32px;
  border-bottom: 1px solid #e1e2e4;
`;

const UpdateDateBox = styled.div`
  padding: 6px 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #f0f6ff;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
`;

const UpdateDate = styled.span`
  color: #008aff;
`;

const ContentBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ContentTitleBox = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: #222222;
  padding: 32px 0 24px;
`;
const SubContentTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #0052bd;
  margin-bottom: 24px;
`;
interface CellProps {
  width: string;
  border?: boolean;
  textAlign?: string;
}

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #616161;
`;

const Row = styled.tr`
  border-bottom: 1px solid #e1e2e4;
`;

const TitleCell = styled.td<CellProps>`
  width: ${({ width }) => width};
  background-color: #f7f8fc;
  color: #616161;
  padding: 10px 12px;
  text-align: left;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 145%;
`;

const ContentCell = styled.td<CellProps>`
  width: ${({ width }) => width};
  padding: 10px 12px;
  text-align: ${({ textAlign }) => textAlign || 'left'};
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  overflow-wrap: break-word;
  color: #222;
  line-height: 145%;
  

  /* &:not(:last-child) {
    border-right: ${({ border }) => (border ? '1px solid #e8e9ea' : 'none')};
  } */
`;
const TableHeadTh = styled.th<CellProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-size: 13px;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
  color: #616161;

  &:not(:last-child) {
    border-right: 1px solid #E1E2E4;
  }
`;

const GrayBox = styled.div`
  width: 100%;
  padding: 16px 24px;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.08);
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;

const TabBox = styled.div`
  width: 100%;
  border-bottom: 1px solid #e1e2e4;
`;

const TabBoxInner = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 8px 16px 0;
`;
const TabButton = styled.div<{ active: boolean }>`
  padding: 10px 0;
  text-align: center;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#222' : '#989BA2')};
  border-bottom: ${({ active }) => (active ? '2px solid #222' : 'none')};
  cursor: pointer;
`;


const Label = styled.div`
  width: 120px;
  padding: 10px 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  overflow-wrap: break-word;
  color: #616161;
  line-height: 145%;
  background: #F7F8FC;
`;

const ContentItem = styled.div`
  flex: 1;
  padding: 10px 12px;
  color: #222;
  white-space: pre-line;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  overflow-wrap: break-word;
`;

export const s = {
  Container,
  Inner,
  PageTitleBox,
  UpdateDateBox,
  UpdateDate,
  Content,
  ContentTitleBox,
  Table,
  Row,
  TitleCell,
  ContentCell,
  TableHeadTh,
  GrayBox,
  ContentBlock,
  SubContentTitle,
  TabBox,
  TabBoxInner,
  TabButton,
  Label,
  ContentItem
};